// hooks/useOverrideBackButton.ts
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { homeRoute } from '../../Home/route.const'

export const useOverrideBackButton = () => {
    const history = useHistory()

    useEffect(() => {
        return () => {
            if (history.action === 'POP') {
                history.push(homeRoute())
            }
        }
    }, [history])
}
